import {
    GET_SUPPLIERS,
    GET_SUPPLIERS_SUCCESS,
    GET_SUPPLIERS_FAIL,
    ADD_NEW_SUPPLIER,
    ADD_NEW_SUPPLIER_SUCCESS,
    ADD_NEW_SUPPLIER_FAIL,
    UPDATE_SUPPLIER,
    UPDATE_SUPPLIER_SUCCESS,
    UPDATE_SUPPLIER_FAIL,
    DELETE_SUPPLIER,
    DELETE_SUPPLIER_SUCCESS,
    DELETE_SUPPLIER_FAIL,
    GET_SUPPLIER_INVOICES,
    GET_SUPPLIER_INVOICES_SUCCESS,
    GET_SUPPLIER_INVOICES_FAIL,
    ADD_NEW_SUPPLIER_INVOICE,
    ADD_NEW_SUPPLIER_INVOICE_SUCCESS,
    ADD_NEW_SUPPLIER_INVOICE_FAIL,
} from "./actionTypes"

export const getSuppliers = (params) => ({
    type: GET_SUPPLIERS,
    payload: params,
})

export const getSuppliersSuccess = (suppliers) => ({
    type: GET_SUPPLIERS_SUCCESS,
    payload: suppliers,
})

export const getSuppliersFail = (error) => ({
    type: GET_SUPPLIERS_FAIL,
    payload: error,
})

export const addNewSupplier = (supplier) => ({
    type: ADD_NEW_SUPPLIER,
    payload: supplier,
})

export const addNewSupplierSuccess = (supplier) => ({
    type: ADD_NEW_SUPPLIER_SUCCESS,
    payload: supplier,
})

export const addNewSupplierFail = (error) => ({
    type: ADD_NEW_SUPPLIER_FAIL,
    payload: error,
})

export const updateSupplier = (supplier) => ({
    type: UPDATE_SUPPLIER,
    payload: supplier,
})

export const updateSupplierSuccess = (supplier) => ({
    type: UPDATE_SUPPLIER_SUCCESS,
    payload: supplier,
})

export const updateSupplierFail = (error) => ({
    type: UPDATE_SUPPLIER_FAIL,
    payload: error,
})

export const deleteSupplier = (id) => ({
    type: DELETE_SUPPLIER,
    payload: id,
})

export const deleteSupplierSuccess = (id) => ({
    type: DELETE_SUPPLIER_SUCCESS,
    payload: id,
})

export const deleteSupplierFail = (error) => ({
    type: DELETE_SUPPLIER_FAIL,
    payload: error,
})

export const getSupplierInvoices = (params) => ({
    type: GET_SUPPLIER_INVOICES,
    payload: params,
})

export const getSupplierInvoicesSuccess = (invoices) => ({
    type: GET_SUPPLIER_INVOICES_SUCCESS,
    payload: invoices,
})

export const getSupplierInvoicesFail = (error) => ({
    type: GET_SUPPLIER_INVOICES_FAIL,
    payload: error,
})

export const addNewSupplierInvoice = (invoice) => ({
    type: ADD_NEW_SUPPLIER_INVOICE,
    payload: invoice,
})

export const addNewSupplierInvoiceSuccess = (invoice) => ({
    type: ADD_NEW_SUPPLIER_INVOICE_SUCCESS,
    payload: invoice,
})

export const addNewSupplierInvoiceFail = (error) => ({
    type: ADD_NEW_SUPPLIER_INVOICE_FAIL,
    payload: error,
})
